import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

export function usePaged(list, pageSize = 10) {
  const [page, setPage] = useState(1);
  const total = list.length;
  const pages = Math.max(1, Math.ceil(total / pageSize));
  useEffect(() => { if (page > pages) setPage(1); }, [pages, page]);
  const slice = list.slice((page - 1) * pageSize, page * pageSize);
  return { page, setPage, pages, total, pageSize, slice };
}

export function Paginator({ page, setPage, pages, total, pageSize }) {
  if (total === 0) return null;
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 px-4 py-3 text-sm" data-testid="paginator">
      <span className="text-muted-foreground">Menampilkan {from}–{to} dari {total}</span>
      <div className="flex items-center gap-1">
        <Button size="icon" variant="outline" className="h-8 w-8" disabled={page <= 1} onClick={() => setPage(page - 1)} data-testid="page-prev"><ChevronLeft className="h-4 w-4" /></Button>
        <span className="px-2 font-medium" data-testid="page-indicator">{page} / {pages}</span>
        <Button size="icon" variant="outline" className="h-8 w-8" disabled={page >= pages} onClick={() => setPage(page + 1)} data-testid="page-next"><ChevronRight className="h-4 w-4" /></Button>
      </div>
    </div>
  );
}
